export const RateWarningType = {
  None: 'None',
  NotSupported: 'NotSupported',
};
